(function () {
  'use strict';
  const clean = value => String(value || '').normalize('NFC')
    .replace(/[\u0000-\u001f\u007f-\u009f|<>]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 160);
  function attributesFor(value) {
    const by = clean(value);
    return {
      mcduffy_referral_by: by,
      mcduffy_referral_program: by ? 'mystery_gift_1000_v1' : '',
      mcduffy_referral_status: by ? 'pending_verification' : '',
      mcduffy_referral_reward: by ? 'Mystery gift worth PHP 1,000 for the referrer on their next order; verify before fulfillment. Not cash or credit.' : ''
    };
  }
  function createSaver(update) {
    let draft = null, saved = '', flight = null;
    return {
      initialize(value) { if (draft === null) draft = saved = clean(value); },
      set(value) { draft = clean(value); },
      get value() { return draft || ''; },
      get dirty() { return draft !== null && draft !== saved; },
      get pending() { return !!flight; },
      flush() {
        if (flight) return flight;
        flight = (async () => {
          while (draft !== null && draft !== saved) {
            const target = draft;
            const cart = await update(attributesFor(target));
            if (String(cart.attributes?.mcduffy_referral_by || '') !== target) throw new Error('referral_readback_mismatch');
            saved = target;
          }
        })().finally(() => { flight = null; });
        return flight;
      }
    };
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { clean, attributesFor, createSaver };
    return;
  }
  if (customElements.get('mcduffy-cart-referral')) return;
  const saver = createSaver(async attributes => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes }), signal: controller.signal
      });
      if (!response.ok) throw new Error('referral_save_failed');
      return await response.json();
    } finally { clearTimeout(timeout); }
  });
  let timer, saving = false, error = false, checkoutWaiting = false;
  function paint() {
    const locked = saver.dirty || saver.pending;
    document.querySelectorAll('#cart-drawer .dynamic-cart-btns').forEach(el => { el.inert = locked; });
    document.querySelectorAll('mcduffy-cart-referral').forEach(el => {
      const status = el.querySelector('[role="status"]');
      status.textContent = error ? 'We couldn’t save your referral. Please try checkout again.' : saving ? 'Saving referral…' : '';
      status.dataset.error = String(error);
      el.setAttribute('aria-busy', String(saving));
    });
  }
  async function save() {
    clearTimeout(timer);
    saving = true; error = false; paint();
    try { await saver.flush(); return true; }
    catch (_) { error = true; return false; }
    finally { saving = false; paint(); }
  }
  class CartReferral extends HTMLElement {
    connectedCallback() {
      saver.initialize(this.dataset.savedValue);
      const input = this.querySelector('input');
      input.value = saver.value; // Preserve the draft when cart quantities replace the drawer HTML.
      input.addEventListener('input', () => {
        saver.set(input.value); error = false; clearTimeout(timer); paint();
        timer = setTimeout(save, 200);
      });
      input.addEventListener('change', save);
      paint();
    }
  }
  customElements.define('mcduffy-cart-referral', CartReferral);
  document.addEventListener('submit', async event => {
    if (event.target.id !== 'cart-drawer-form') return;
    const input = event.target.querySelector('#md-cart-referred-by');
    if (!input) return;
    saver.set(input.value);
    input.value = saver.value;
    if (!saver.dirty && !saver.pending) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutWaiting) return;
    checkoutWaiting = true;
    const submitter = event.submitter;
    try {
      if (!await save()) return;
      const form = document.getElementById('cart-drawer-form');
      if (!form) return;
      // Re-enter native validation/terms handling, then Shopify atomically saves
      // the final attributes and redirects to checkout via the standard cart POST.
      const button = submitter?.isConnected ? submitter : document.querySelector('#cart-drawer [name="checkout"]');
      if (button && !button.disabled) form.requestSubmit(button);
    } finally { checkoutWaiting = false; }
  }, true);
}());
